module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-135.dcae797.woff2";